export const WEBAPP_ENV_VARS_GROUP = 'links'
